import { Flex } from 'antd'
import type { ShipmentColumn } from '../../types/column-types'
import { onCellStandard, renderShipment } from '../../helpers/helpers'
import ShipmentWithoutCutting from '../../components/cells/without-cutting/without-cutting'
import { RotatedTitle } from '../../../../components/rotated-title/rotated-title'

export const withoutCuttingColumn: ShipmentColumn = {
    dataIndex: 'withoutCutting',
    title: <RotatedTitle style={{ whiteSpace: 'nowrap' }}>Без выс</RotatedTitle>,
    width: 32,
    render: renderShipment(r => {
        return (
            <Flex justify={'center'}>
                <ShipmentWithoutCutting checked={r.withoutCutting} />
            </Flex>
        )
    }),
    onCell: onCellStandard,
}
